import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import TenderingLandingPageContext from "../../../contexts/TenderingLandingPageContext";
import Header from "./Header";
import Recommend from "./Recommend";
import Urgent from "./Urgent";
import List from "./List";

const LandingPage = (props) => {
  const [filter, setFilter] = useState({});

  const contextValues = useMemo(
    () => ({
      filter,
      setFilter,
    }),
    [filter]
  );

  return (
    <TenderingLandingPageContext.Provider value={contextValues}>
      <div className="tendering__landing">
        <Header />
        <Recommend />
        <Urgent />
        <List />
      </div>
    </TenderingLandingPageContext.Provider>
  );
};

export default LandingPage;
